import * as wjcSheet from '@grapecity/wijmo.grid.sheet';

import { UnitOperationFlexSheetEventHandler } from './unit-operation-flex-sheet-event-handler';
import { enumValuesToArray } from '../../../_utils/enum-values-to-array';
import { DiluentSourceCellConfig, DiluentSourceSheetRows } from '../cell-config/diluent-source-cell-config';
import { NumberToSimulationVariableMapper } from '../mappers/number-to-simulation-variable-mapper';
import { FlexSheetValueConverter } from '../flex-sheet-value-converter';
import { DiluentSource } from '../../../_models/_unit-operations/diluent-source';
import { DiluentSourceFlexSheetMapper } from '../mappers/diluent-source-flex-sheet-mapper';

export class DiluentSourceFlexSheetEventHandler implements UnitOperationFlexSheetEventHandler {
  constructor(private valueConverter: FlexSheetValueConverter) {}

  handle(unitOperation: DiluentSource, spreadsheet: wjcSheet.FlexSheet, flexSheetEvent, rawValue) {
    const { row } = flexSheetEvent;

    if (enumValuesToArray(DiluentSourceSheetRows).indexOf(row) === -1) {
      flexSheetEvent.cancel = true;
      return;
    }

    const cellConfig = DiluentSourceCellConfig.find(rowConfig => rowConfig.row === row);
    const convertedValue = this.valueConverter.convert(spreadsheet, rawValue, cellConfig);

    const simulationVariableMapper = new NumberToSimulationVariableMapper();
    const mapper = new DiluentSourceFlexSheetMapper(simulationVariableMapper);

    mapper.map(unitOperation, row, convertedValue);
  }
}
